<template>
  <div class="field">
    <p class="item-label"></p>
    <label class="switch">
      <input type="checkbox" v-model="val" />
      <span class="slider round"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "Bool",
  props: {
    value: Boolean
  },
  data() {
    return {
      val: this.value || false
    };
  },
  mounted() {
    if (!this.value) {
      this.$emit("input", this.val);
    }
  },
  watch: {
    val() {
      this.$emit("input", this.val);
    },
    value() {
      this.val = this.value;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>